module.exports = __webpack_public_path__ + "static/media/instagram-logo.e4b4804d.svg";